import type { GtmConsentChoice } from './gtm';

const TRAVELPAYOUTS_SRC = 'https://mn-tz.com/NDMwNTU5.js?t=430559';

export interface ConsentScriptChoice {
  analytics: boolean;
  marketing: boolean;
}

export function loadTravelpayouts(options?: { allowInDev?: boolean }): void {
  if (import.meta.env.DEV && !options?.allowInDev) return;
  if (typeof document === 'undefined') return;
  if (document.querySelector('script[data-citysage="travelpayouts"]')) return;

  const script = document.createElement('script');
  script.async = true;
  script.src = TRAVELPAYOUTS_SRC;
  script.dataset.citysage = 'travelpayouts';
  document.head.appendChild(script);
}

export interface ConsentScriptDeps {
  syncGtm: (
    consent: GtmConsentChoice | null,
    options?: { allowInDev?: boolean }
  ) => void;
  applyAppInsights: (enabled: boolean) => void;
  loadMouseflow: () => void;
  loadTravelpayouts: () => void;
}

export function applyConsentChoice(
  consent: ConsentScriptChoice | null,
  deps: ConsentScriptDeps
): void {
  const analytics = !!consent?.analytics;
  const marketing = !!consent?.marketing;

  deps.syncGtm(analytics || marketing ? { analytics, marketing } : null);
  deps.applyAppInsights(analytics);

  if (analytics) {
    deps.loadMouseflow();
  }

  if (marketing) {
    deps.loadTravelpayouts();
  }
}
